import React, { useState } from 'react';
import PropTypes from 'prop-types';

import SimpleSpinner from '~components/SimpleSpinner';

import Loading from './components/loading';
import { SPINNER_TYPES } from './components/constants';

export default function withSpinner({
  WrappedComponent,
  className,
  width,
  height,
  type,
  loop,
  autoplay,
  delay,
  simple,
  rendererSettings
}) {
  function Spinner({ loading, ...props }) {
    const [mounted, setMounted] = useState(delay <= 0);
    const Loader = simple ? SimpleSpinner : Loading;

    setTimeout(() => {
      setMounted(true);
    }, delay);

    if (!mounted) {
      return loading ? null : <WrappedComponent {...props} />;
    }

    return loading ? (
      <Loader
        className={className}
        width={width}
        height={height}
        type={type}
        loop={loop}
        autoplay={autoplay}
        rendererSettings={rendererSettings}
        containerClassName={className}
      />
    ) : (
      <WrappedComponent {...props} />
    );
  }

  Spinner.propTypes = {
    loading: PropTypes.bool,
    props: PropTypes.object // eslint-disable-line react/forbid-prop-types
  };

  return Spinner;
}

withSpinner.propTypes = {
  classNameContainer: PropTypes.string,
  classNameLoading: PropTypes.string,
  colorSpinner: PropTypes.string,
  delay: PropTypes.number,
  simple: PropTypes.bool,
  type: PropTypes.oneOf(Object.keys(SPINNER_TYPES)),
  typeLoading: PropTypes.oneOf(Object.keys(SPINNER_TYPES)),
  WrappedComponent: PropTypes.node
};

withSpinner.defaultProps = {
  classNameContainer: '',
  delay: 0
};
